import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import type { ExecResult } from "@/types";

export const RUN_AS_USERS = ["claude", "agent-mesh-admin", "agent-mesh-user"] as const;
export type RunAsUser = typeof RUN_AS_USERS[number];

export interface ExecRequest {
  agentId: string;
  cmd: string[];
  timeoutMs?: number;
  env?: Record<string, string>;
  /** Admin-only Override. Default vom Master: agent-mesh-admin (admin) bzw.
   *  agent-mesh-user (owner). Für Brain-User-Operations (z.B. `claude plugin
   *  install`) muss runAs="claude" gesetzt sein. */
  runAs?: RunAsUser;
}

// Exec-Hook. Kein invalidate — exec ist read-only von DB-Sicht.
export function useExecAgent(): UseMutationResult<ExecResult, Error, ExecRequest> {
  const { session, logout } = useAuth();
  return useMutation({
    mutationFn: ({ agentId, cmd, timeoutMs, env, runAs }) => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.post<ExecResult>(`/agents/${agentId}/exec`, { cmd, timeoutMs, env, runAs });
    },
  });
}
